import React from 'react';

const StoreOverallsStatusesIndex = React.lazy(() => import("./index"))
const NewStoreOverallsStatuses = React.lazy(() => import("./new"))
const EditStoreOverallsStatuses = React.lazy(() => import("./edit"))

export default[
	{path:'/store/overalls/statuses/:id/edit',component: EditStoreOverallsStatuses,name:'Edit StoreOverallsStatus'},
	{path:'/store/overalls/statuses/new',component: NewStoreOverallsStatuses,name:'New StoreOverallsStatus'},  
	{path:'/store/overalls/statuses',component: StoreOverallsStatusesIndex,name:'StoreOverallsStatuses'}, 
]

// import StoreOverallsStatusesRoutes from "modules/store/overalls/statuses/web/routes"
// routes = _.concat(routes,StoreOverallsStatusesRoutes)
